// extracted by mini-css-extract-plugin
export var leftAlign = "_r-2";
export var popper = "_r-0";
export var subtitle = "_r-1";